/**
 * 生成配置化页面路由
 * @param config 页面基础配置
 * @param layout 布局组件（必填）
 * @param options 可选配置
 * @returns 完整路由配置
 */
export function generateConfigRoute(
  nlConfig: {
    title: string
    pageId: string // 配置化page_id
    isRootRoute?: boolean // 是否是根路由
  },
  extra?: {
    routeConfig?: Record<string, any>
    metaConfig?: Record<string, any>
    propsConfig?: Record<string, any>
  },
): any {
  const path = `${nlConfig.isRootRoute ? '/' : ''}nl/${nlConfig.pageId}`

  return {
    path,
    name: nlConfig.pageId,
    ...extra?.routeConfig,
    meta: {
      title: nlConfig.title,
      payment: 'free',
      icon: 'front_page',
      ...extra?.metaConfig,
    },
    props: () => ({
      id: nlConfig.pageId,
      key: nlConfig.pageId,
      ...extra?.propsConfig,
    }),
  }
}
